import Swiper from 'swiper';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import EA from '../helpers/init';

export default EA.Methods.gallerySlider = ($this) => {
    const gallerySliderEl = $this.querySelector('.gallery-swiper');

    const gallerySliderPrevEl = $this.querySelector('.swiper-button-prev');
    const gallerySliderPaginationEl = $this.querySelector('.gallery-swiper-pagination');
    const gallerySliderNextEl = $this.querySelector('.swiper-button-next');

    const gallerySlider = new Swiper(gallerySliderEl, {
        modules: [Autoplay, Pagination, Navigation],
        speed: 1200,
        slidesPerView: 'auto',
        loop: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        pagination: {
            el: gallerySliderPaginationEl,
            type: 'fraction',
            clickable: true,
        },
        navigation: {
            prevEl: gallerySliderPrevEl,
            nextEl: gallerySliderNextEl,
        }
    });
};